import api from '@a/config';
import typ from './typ';

const path = 'v1/dokument';

export default {
  typ,
  delete: (id) => api.delete(`${path}/${id}`),
};
